module.exports = __webpack_public_path__ + "static/media/ajuda-corlett-EN.4f4907ff.jpg";